<template>
  <v-container>
    <v-row>
      <v-col>
        <h4>Listagem de escolas por município</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ComboboxMunicipio
          :filter="payload"
          @changeCity="loadByMunicipio"
        ></ComboboxMunicipio>
      </v-col>
    </v-row>
    <v-row>
      <v-form ref="form" style="width: 100%">
        <v-data-table
          style="width: 100%"
          :headers="headers"
          :items="municipioEscola"
          class="elevation-1"
          :search="search"
          :items-per-page="20"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-options': [20, 50, 100, -1],
            'items-per-page-text': 'Items por página',
          }"
        >
          <template v-slot:footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }}
          </template>
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Pesquisar"
              class="mx-4"
            ></v-text-field>
          </template>
          <template v-slot:item.situacao="{ item }">
            <v-switch
              class="tema-eixo-combo"
              id="temas-select"
              v-model="item.situacao"
              label="Atua"
              @change="
                (e) => {
                  if (!e) {
                    item.inicio = null;
                    item.fim = null;
                  } else {
                    item.inicio = '01/2025';
                    item.fim = '12/2025';
                  }
                }
              "
            >
            </v-switch>
          </template>
          <template v-slot:item.inicio="{ item }">
            <v-col>
              <v-text-field
                v-model="item.inicio"
                outlined
                label="Ínicio"
                name="inicio"
                type="text"
                hide-details="auto"
                v-mascara="'##/####'"
                placeholder="MM/AAAA"
                :disabled="!item.situacao"
                :rules="[item.situacao ? obrigatorio : true, data]"
              ></v-text-field>
            </v-col>
          </template>
          <template v-slot:item.fim="{ item }">
            <v-col>
              <v-text-field
                v-model="item.fim"
                outlined
                label="Fim"
                name="fim"
                type="text"
                hide-details="auto"
                v-mascara="'##/####'"
                placeholder="MM/AAAA"
                :disabled="!item.situacao"
                :rules="[item.situacao ? obrigatorio : true, data]"
              ></v-text-field>
            </v-col>
          </template>

          <template slot="no-data">
            <span> Nenhum anexo retornado </span>
          </template>
        </v-data-table>
      </v-form>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="primary" @click="salvar"> Salvar </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ComboboxMunicipio from "@/modules/city/components/ComboboxSingle.vue";
import situacaoMunicipioEscolaEnum from "./situacaoMunicipioEscolaEnum";
import moment from "moment";
import { dataRegexValidatior } from "@/helpers/validator";
import { municipioEscolaApi } from "@/apis";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ComboboxMunicipio,
  },
  name: "ListarMunicipiosEscola",
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      payload: {},
      headers: [
        { text: "Município", value: "nomeMunicipio" },
        { text: "Escola", value: "nomeEscola" },
        { text: "Situação", value: "situacao" },
        { text: "Início", value: "inicio", width: "20%" },
        { text: "Fim", value: "fim", width: "20%" },
      ],
      obrigatorio: (v) => !!v || "Campo Obrigatório",
      data: (v) => {
        if (!v) return true;
        if (!dataRegexValidatior.test(`10/${v}`) || v.length < 7) {
          return "Data inválida";
        }

        return true;
      },
      search: "",
      municipioEscola: [],
    };
  },
  beforeMount() {
    // this.load();
  },
  methods: {
    ...mapActions(["setLoading"]),

    async loadByMunicipio(val) {
      try {
        this.setLoading(true);
        const data = await municipioEscolaApi.list(val.codigoIBGE);

        this.municipioEscola = data.data.map((item) => ({
          ...item,
          situacao:
            situacaoMunicipioEscolaEnum.semAtuacao == item.situacao
              ? false
              : true,
          inicio: item.inicio
            ? moment(item.inicio, "YYYY-MM-DD").format("MM/YYYY")
            : null,
          fim: item.fim
            ? moment(item.fim, "YYYY-MM-DD").format("MM/YYYY")
            : null,
        }));
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        this.$notification.error("Erro ao obter dados");
      }
    },
    async check() {
      if (!this.$refs.form) return true;
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async salvar() {
      const valid = await this.check();
      if (!valid) return;

      const fim = this.municipioEscola.map((item) => ({
        ...item,
        inicio: item.inicio
          ? moment(`1/${item.inicio} 00:00:00`, "DD/MM/YYYY HH:mm:ss").format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : null,
        fim: item.fim
          ? moment(`1/${item.fim} 23:59:00`, "DD/MM/YYYY HH:mm:ss")
              .endOf("month")
              .format("YYYY-MM-DD HH:mm:ss")
          : null,
        usuarioid: this.user.usuarioid,
        dataAlteracao: moment().format("YYYY-MM-DD HH:mm:ss"),
      }));

      try {
        this.setLoading(true);

        await municipioEscolaApi.update(fim);
        this.setLoading(false);
        this.$notification.success("Atualizado com sucesso");

        // this.loadByMunicipio();
      } catch (error) {
        console.log("🚀 ~ salvar ~ error:", error);
        this.setLoading(false);
        this.$notification.error("Erro ao salvar");
      }
    },
  },
};
</script>
